import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { registerGoogleHome } from '../Networking/APIClient';
import LanguageIcon from '@material-ui/icons/Language';
import LanguageSelectionDialog from '../Components/LanguageSelectionDialog';
import Typography from '@material-ui/core/Typography';
import Logo from '../logo.png';

let t;
let self;

const PROJECT_ID = 'sikom-home';

class LoginAuth extends React.Component {
    constructor(props) {
        super(props);
        self = this;

        this.state = {
            email: {
                value: '',
                error: false,
                helperText: ''
            },
            password: {
                value: '',
                error: false,
                helperText: ''
            },


            initialCredentials: props.initialCredentials,
            showPassword: false,
            languageSelectionDialogOpen: false,
        }

        this.finishSetup = this.finishSetup.bind(this);

        t = props.getTranslation;
    }

    handleLanguageClickOpen = () => {
        this.setState({
            languageSelectionDialogOpen: true,
        });
    };

    handleLanguageClickClose = value => {
        this.setState({ selectedValue: value, languageSelectionDialogOpen: false });
    };

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    onLinkClicked = e => {
        if (e != null) {
            e.preventDefault();
        }

        const myCredentials = {
            email: this.state.email.value,
            password: this.state.password.value
        }

        const onOk = function onOk(bpapi_result) {
            self.setState((prevState) => ({
                email: {
                    value: prevState.email.value,
                    error: false,
                    helperText: ''
                },
                password: {
                    value: prevState.password.value,
                    error: false,
                    helperText: ''
                },
            }));

            self.finishSetup(bpapi_result);
        }

        const onError = function onError() {
            //self.props.setLoading(false);

            self.setState((prevState) => ({
                email: {
                    value: prevState.email.value,
                    error: true,
                    helperText: t('wrong_email_or_password')
                },
                password: {
                    value: prevState.password.value,
                    error: true,
                    helperText: t('wrong_email_or_password')
                },
            }));
        }

        if (this.state.email.value === '' || this.state.password.value === '') {
            return;
        }

        // Tell main to show the full page loading circle.
        // It will be hidden once AccountOverview is mounted.
        //this.props.setLoading(true);

        registerGoogleHome(myCredentials, self.props.clientId, onOk, onError);

    }

    finishSetup(bpapi_result) {
        console.log("Finishing setup. Sending to google");
        // Keep in mind that the # before access_token is a ? in the docs, however there seems to be an error in the docs.
        const url = "https://oauth-redirect.googleusercontent.com/r/" + PROJECT_ID + "#access_token=" + bpapi_result.token + "&token_type=bearer&state=" + this.props.state + "";
        console.log(url);
        window.location.replace(url);
    }

    componentDidMount() {

    }


    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
    }

    render() {
        const { classes, onClose, selectedValue, ...other } = this.props;

        const emailPaswordContent =
            <form>
                <TextField style={topEditTextStyle}
                    id="email"
                    label={t('email')}
                    value={this.state.email.value}
                    error={this.state.email.error}
                    helperText={this.state.email.helperText}
                    onChange={this.handleChange('email')}
                    onKeyPress={e => this.onKeyPressed(e)}
                    margin="normal"
                />
                <br />
                <FormControl style={editTextStyle}>
                    <InputLabel htmlFor="adornment-password">{t('password')}</InputLabel>
                    <Input
                        id="adornment-password"
                        type={this.state.showPassword ? 'text' : 'password'}
                        value={this.state.password.value}
                        error={this.state.password.error}
                        onChange={this.handleChange('password')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={this.handleClickShowPassword}
                                    onMouseDown={this.handleMouseDownPassword}
                                >
                                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
                <Button type="submit" style={loginButtonStyle} variant="contained" color="secondary" onClick={e => this.onLinkClicked(e)}>{t('link')}</Button>
            </form>;

        return (
            <div className="Login">
                {/*this.props.paymentStatus !== null ? paymentStatusContent : null*/}

                <Paper className="login-content-centered">

                    <div >
                        <img src={Logo} alt="Logo" className="Logo" />
                    </div>

                    <Typography className="login-title-container" variant="subheading">
                        {t('sikom_account_manager_auth_info')}
                    </Typography>

                    {emailPaswordContent}

                    <div className='bottom-container-auth'>
                        <div>
                            <Button color="secondary" onClick={this.handleLanguageClickOpen}>
                                <LanguageIcon style={languageIconStyle} />
                                {this.props.language === 'nb-NO' ? 'Norsk' : 'English'}
                            </Button>
                            <LanguageSelectionDialog
                                selectedValue={this.state.selectedValue}
                                open={this.state.languageSelectionDialogOpen}
                                onClose={this.handleLanguageClickClose}
                                language={this.props.language}
                                setAndDownloadLanguage={this.props.setAndDownloadLanguage}
                            />
                        </div>
                    </div>
                </Paper>
            </div>



        );
    }
}

export default LoginAuth;

const languageIconStyle = {
    paddingRight: 10,
};

const loginButtonStyle = {
    marginTop: 30,
    position: "relative",
    width: "80%"
};

const editTextStyle = {
    position: "relative",
    width: "80%"
}

const topEditTextStyle = {
    marginTop: 20,
    position: "relative",
    width: "80%"
}


// WEBPACK FOOTER //
// ./src/Pages/LoginAuth.js